import { Close } from "@mui/icons-material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, IconButton, Modal, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MyJobAlertModal from "./MyJobAlertModal";
import ResumeList from "./ResumeList";
import FavoriteJobsModal from "./FavoriteJobsModal";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";

const MyJobsModal = ({
  visible,
  onClose,
  onNewAlertCreated,
  onFavoriteModalClose,
  onFavoriteToggle,
  favoriteLoadingKeys
}) => {
  const navigate = useNavigate();
  const [showJobAlertsModal, setShowJobAlertsModal] = useState(false);
  const [showResumeListModal, setShowResumeListModal] = useState(false);
  const [showFavoriteJobsModal, setShowFavoriteJobsModal] = useState(false);

  const { multiLanguageData } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.JobPostings || {};

  const {
    TEXT_MY_JOBS = English.JobPostings.TEXT_MY_JOBS || "My Jobs",
    TEXT_MY_POSTING_BTN = English.JobPostings.TEXT_MY_POSTING_BTN || "My Postings",
    TEXT_MY_RESUMES = English.JobPostings.TEXT_MY_RESUMES || "My Resumes",
    TEXT_JOB_ALERTS = English.JobPostings.TEXT_JOB_ALERTS || "Job Alerts",
    TEXT_FAVORITE_JOBS = English.JobPostings.TEXT_FAVORITE_JOBS || "Favorite Jobs"
  } = LanguageData || {};

  const MyJobsData = [
    { id: 1, title: TEXT_MY_POSTING_BTN, onClick: () => navigate("/my-postings") },
    { id: 2, title: TEXT_MY_RESUMES, onClick: () => setShowResumeListModal(true) },
    { id: 3, title: TEXT_JOB_ALERTS, onClick: () => setShowJobAlertsModal(true) },
    { id: 4, title: TEXT_FAVORITE_JOBS, onClick: () => setShowFavoriteJobsModal(true) }
  ];

  const renderedMyJobsData = (data) => {
    return data.map((item) => (
      <Box
        key={item.id}
        sx={{
          p: 1,
          border: "1px solid #E0E0E0",
          borderRadius: 1,
          cursor: "pointer"
        }}
        onClick={() => {
          item.onClick();
        }}>
        <Stack sx={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
          <Typography sx={{ fontSize: 16 }}>{item.title}</Typography>
          <IconButton
            onClick={() => {
              // item.onClick()
            }}>
            <KeyboardArrowRightIcon />
          </IconButton>
        </Stack>
      </Box>
    ));
  };
  return (
    <>
      <Modal open={visible} onClose={onClose}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6" sx={{ fontSize: 18 }}>
              {TEXT_MY_JOBS}
            </Typography>
            <Stack flexDirection={"row"}>
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </Stack>
          </Box>

          <Stack sx={{ mt: 3, gap: 2 }}>{renderedMyJobsData(MyJobsData)}</Stack>
        </Box>
      </Modal>
      <MyJobAlertModal
        visible={showJobAlertsModal}
        onClose={() => setShowJobAlertsModal(false)}
        onNewAlertCreated={onNewAlertCreated}
      />
      {showResumeListModal && (
        <ResumeList
          open={showResumeListModal}
          setOpenResumeListModal={setShowResumeListModal}
          from="myJobsModal"
        />
      )}
      <FavoriteJobsModal
        open={showFavoriteJobsModal}
        onClose={() => {
          setShowFavoriteJobsModal(false);
          if (onFavoriteModalClose) onFavoriteModalClose();
        }}
        onFavoriteToggle={onFavoriteToggle}
        favoriteLoadingKeys={favoriteLoadingKeys}
      />
    </>
  );
};

export default MyJobsModal;
